var map = {
	"./EYES1.svg": 572,
	"./EYES2.svg": 67727,
	"./EYES3.svg": 10175,
	"./EYES4.svg": 77733,
	"./EYES5.svg": 57913,
	"./EYES6.svg": 8017,
	"./EYES7.svg": 60940,
	"./EYES8.svg": 24599,
	"./EYES9.svg": 92006
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 26521;